import { render, staticRenderFns } from "./allinpayTransferRecord.vue?vue&type=template&id=ad60ab04&scoped=true"
import script from "./allinpayTransferRecord.vue?vue&type=script&lang=ts"
export * from "./allinpayTransferRecord.vue?vue&type=script&lang=ts"
import style0 from "./allinpayTransferRecord.vue?vue&type=style&index=0&id=ad60ab04&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad60ab04",
  null
  
)

export default component.exports